import React from 'react'
import { IconButton } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { Card, LineChart, Text } from '@tremor/react'

const data = [
  { name: 'enero', value: 34 },
  { name: 'febrero', value: 32 },
  { name: 'marzo', value: 15 },
  { name: 'abril', value: 27 },
  { name: 'mayo', value: 34 },
  { name: 'junio', value: 32 },
  { name: 'julio', value: 15 },
  { name: 'agosto', value: 27 },
  { name: 'septiembre', value: 34 },
  { name: 'octubre', value: 32 },
  { name: 'noviembre', value: 15 },
  { name: 'diciembre', value: 27 },
  { name: 'enero', value: 35 },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const downloadCSV = () => {
  const csvRows = [['Mes', 'Valor'], ...data.map(row => [row.name, row.value])]
  const csvContent = csvRows.map(e => e.join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'tickets_por_app.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export const TicketsByAppGeneral = () => (
  <Card className="p-8">
    <div className="flex flex-row justify-between items-start mb-2">
      <div className="flex flex-col gap-2">
        <Text className="text-lg font-bold" style={montserratStyle}>
          Tickets x APP (marca)
        </Text>
        <Text className="text-4xl font-extrabold" style={montserratStyle}>
          19,41%
        </Text>
        <div className="flex items-center gap-2 mt-1">
          <span
            className="font-bold rounded-lg px-2 py-1 flex items-center text-base"
            style={{ ...montserratStyle, background: '#C1FD96CC', color: '#1E1E1E' }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#047857"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mr-1"
            >
              <path d="M6 15l6-6 6 6" />
            </svg>
            +3%
          </span>
          <Text className="text-gray-600 text-base" style={montserratStyle}>
            (comparado con el mes anterior)
          </Text>
        </div>
      </div>
      <IconButton className="ml-2" aria-label="download" onClick={downloadCSV}>
        <GetAppIcon />
      </IconButton>
    </div>
    <div className="mt-4">
      <LineChart
        className="h-80"
        data={data}
        index="name"
        categories={['value']}
        colors={['black']}
        valueFormatter={number => `${number}`}
        showLegend={false}
        showGridLines
        showAnimation
        yAxisWidth={40}
        minValue={0}
        maxValue={40}
      />
    </div>
  </Card>
)
